import { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'js-c... Remove this comment to see the full error message
import Cookies from 'js-cookie';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import * as LoginUtils from '../../lib/LoginUtils';
import ErrorMessage from '../alerts/ErrorMessage';
import TokenExpiredAlert from '../alerts/TokenExpiredAlert';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIButton from 'UIComponents/button/UIButton';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UITextInput from 'UIComponents/input/UITextInput';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { parse as parseQuery, stringify as stringifyQuery } from 'hub-http/helpers/params';
import IE11Alert from '../alerts/IE11Alert';
import selectSessionInvalidationWarning from '../../utils/selectSessionInvalidationWarning';
import { LoginOptions } from './LoginOptions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.onClickContinue = () => {
      const {
        loginRedirectUrl
      } = this.props;
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
      window.location.href = loginRedirectUrl;
    };
    this.handleShowPasswordToggle = () => {
      this.setState({
        showPassword: !this.state.showPassword
      });
    };
    this.handleFocusEmailElement = () => {
      this.setState({
        emailFocused: true,
        loggingInWithGoogle: false
      });
    };
    // If we click on the body element the related target will be null. Otherwise the related target is the element being clicked.
    // If we click on the google sign in form do not show the invalid error message state
    this.handleBlurEmailElement = () => {
      if (!this.state.loggingInWithGoogle) {
        this.setState({
          emailFocused: false
        });
      }
    };
    this.handleGoogleLoginClick = () => {
      this.setState({
        loggingInWithGoogle: true
      });
      this.props.onGoogleLoginClick(this.triggerReset);
    };
    this.handleInputChange = (name, evt) => {
      const {
        target: {
          value
        }
      } = evt;
      if (name === 'email') {
        this.setState({
          email: value
        });
      } else if (name === 'password') {
        this.setState({
          password: value
        });
      }
    };
    this.isSubmittable = (email, isEmailAutofilled, isPasswordAutoFilled, password) => {
      const emailSatisfied = isEmailAutofilled || !!email && LoginUtils.isValidEmail(email);
      const passwordSatisfied = isPasswordAutoFilled || !!password && password.length >= 6;
      return emailSatisfied && passwordSatisfied;
    };
    this.isValidEmail = email => {
      return !!email && LoginUtils.isValidEmail(email);
    };
    this.onRememberMeChange = ({
      target: {
        checked
      }
    }) => {
      this.setState({
        rememberLogin: checked
      });
    };
    this.onFormSubmit = event => {
      event.preventDefault();
      const {
        onLoginSubmit
      } = this.props;
      const {
        email,
        password,
        rememberLogin
      } = this.state;
      const data = {
        email,
        password,
        rememberLogin
      };
      data.email = LoginUtils.trimEmail(email);
      this.setState({
        submitting: true,
        error: ''
      });
      onLoginSubmit(data, this.triggerReset);
    };
    this.triggerReset = (error, errorTokens) => {
      var _errorTokens$vettingU;
      const newState = {
        submitting: false,
        error,
        vettingUrl: errorTokens === null || errorTokens === void 0 || (_errorTokens$vettingU = errorTokens.vettingUrl) === null || _errorTokens$vettingU === void 0 ? void 0 : _errorTokens$vettingU[0]
      };
      this.setState(newState);
    };
    this.renderEmailElement = (email, emailFocused, validEmail, submitting, useDark, isMarketingVariant) => {
      const error = email !== '' && !emailFocused && !validEmail;
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIFormControl, {
          htmlFor: "username",
          className: `m-bottom-${isMarketingVariant ? '0' : '4'}`,
          label: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.form.email"
          }),
          error: error,
          validationMessage: error && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.formValidation.invalidEmail"
          }),
          children: /*#__PURE__*/_jsx(UITextInput, {
            autoFocus: true,
            id: "username",
            onFocus: this.handleFocusEmailElement,
            onBlur: this.handleBlurEmailElement,
            type: "email",
            className: "login-email",
            value: this.state.email,
            onChange: this.handleInputChange.bind(null, 'email'),
            disabled: submitting
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            ,
            tabIndex: "1",
            use: useDark === 'true' ? 'on-dark' : 'default'
          })
        })
      });
    };
    this.renderPasswordElement = (submitting, email, useDark, loginRedirectUrl, googleLoginRedirectUrl, isMarketing) => {
      const query = {
        email,
        useDark,
        loginRedirectUrl,
        googleLoginRedirectUrl
      };
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIFormControl, {
          htmlFor: "password",
          label: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.form.password"
          }),
          help: /*#__PURE__*/_jsx(UIButton, {
            use: "link",
            onClick: this.handleShowPasswordToggle,
            children: this.state.showPassword ? I18n.text('login.form.hidePassword') : I18n.text('login.form.showPassword')
          }),
          description: /*#__PURE__*/_jsx(Link, {
            to: {
              pathname: '/forgot',
              search: `?${stringifyQuery(query)}`
            },
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "login.form.forgotPassword"
            })
          }),
          children: /*#__PURE__*/_jsx(UITextInput, {
            id: "password",
            type: this.state.showPassword ? 'text' : 'password',
            className: `login-password m-bottom-${isMarketing ? '2' : '3'}`,
            value: this.state.password,
            onChange: this.handleInputChange.bind(null, 'password'),
            disabled: submitting
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            ,
            tabIndex: "2",
            use: useDark === 'true' ? 'on-dark' : 'default'
          })
        })
      });
    };
    this.renderRememberMeElement = (submitting, rememberLogin, isMarketing) => {
      return /*#__PURE__*/_jsx(UICheckbox, {
        "data-test-id": "remember-me",
        id: "remember",
        className: `m-bottom-${isMarketing ? '2' : '4'}`,
        checked: rememberLogin,
        onChange: this.onRememberMeChange,
        disabled: submitting,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "login.form.remember"
        })
      });
    };
    this.renderSubmitButtonElement = (submittable, submitting, isMarketing) => {
      if (submitting) {
        return /*#__PURE__*/_jsx(UILoadingSpinner, {
          grow: true,
          minHeight: "56px"
        });
      } else {
        return /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "password-login-button",
          id: "loginBtn",
          type: "submit",
          use: "primary",
          className: `m-bottom-${isMarketing ? '0' : '4'} login-submit`,
          disabled: !submittable,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.form.button"
          })
        });
      }
    };
    this.renderSsoLoginButton = () => {
      const {
        email
      } = this.state;
      return /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "sso-login-button",
        id: "ssoBtn",
        type: "button",
        use: "tertiary",
        className: "width-100",
        onClick: () => this.props.onSsoLoginClick(email),
        children: /*#__PURE__*/_jsx(UITruncateString, {
          className: "width-100",
          reverse: true,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.form.sso.loginButton"
          })
        })
      });
    };
    const {
      search
    } = props.location;
    const _query = parseQuery(search.substr(1));
    const _rememberLogin = Cookies.get('prefs') === '1';
    this.state = {
      email: _query['email'] ? _query['email'].toString() : '',
      emailFocused: false,
      loggingInWithGoogle: false,
      error: '',
      isEmailAutofilled: false,
      isPasswordAutoFilled: false,
      password: '',
      queryParamError: _query['loginError'] ? _query['loginError'].toString() : '',
      showPassword: false,
      submitting: false,
      rememberLogin: _rememberLogin
    };
  }
  componentDidMount() {
    setTimeout(() => {
      try {
        this.setState({
          isEmailAutofilled: document.querySelectorAll('#username:-webkit-autofill').length > 0,
          isPasswordAutoFilled: document.querySelectorAll('#password:-webkit-autofill').length > 0
        });
        // eslint-disable-next-line no-empty
      } catch (ex) {}
    }, 500);

    // This allows automation to hook into the page for easy login. (For example speedcurve)
    window._hubspotAutomatedLoginHook = this.handleInputChange;
  }
  render() {
    const {
      email,
      emailFocused,
      password,
      error,
      isEmailAutofilled,
      isPasswordAutoFilled,
      queryParamError,
      submitting,
      rememberLogin
    } = this.state;
    const {
      variant
    } = this.props;
    const isMarketingVariant = variant === 'marketing';
    const submittable = !submitting && this.isSubmittable(email, isEmailAutofilled, isPasswordAutoFilled, password);
    const validEmail = this.isValidEmail(email);
    const {
      location,
      isInvalidTokenAlertVisible
    } = this.props;
    const query = parseQuery(location.search.substr(1));
    const {
      loginRedirectUrl,
      googleLoginRedirectUrl,
      authFailureReason
    } = query;
    const useDark = query['useDark'] ? query['useDark'].toString() : '';
    const updatedError = isInvalidTokenAlertVisible ? 'LOGIN_UNAVAILABLE' : error;
    const sessionInvalidationWarning = selectSessionInvalidationWarning(
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | string[]' is not assign... Remove this comment to see the full error message
    authFailureReason);
    return /*#__PURE__*/_jsxs("form", {
      style: {
        backgroundColor: 'white'
      },
      id: "hs-login",
      onSubmit: this.onFormSubmit,
      children: [/*#__PURE__*/_jsx(IE11Alert, {}), /*#__PURE__*/_jsx(ErrorMessage, {
        error: queryParamError || sessionInvalidationWarning,
        type: queryParamError ? 'danger' : 'info',
        prefix: queryParamError ? 'login.errors' : 'login.warnings'
      }), this.renderEmailElement(email, emailFocused, validEmail, submitting, useDark, isMarketingVariant), this.renderPasswordElement(submitting, email, useDark, loginRedirectUrl, googleLoginRedirectUrl, isMarketingVariant), this.renderRememberMeElement(submitting, rememberLogin, isMarketingVariant), /*#__PURE__*/_jsx(ErrorMessage, {
        error: updatedError,
        vettingUrl: this.state.vettingUrl
      }), /*#__PURE__*/_jsx(TokenExpiredAlert, {}), this.renderSubmitButtonElement(submittable, submitting, isMarketingVariant), isMarketingVariant ? /*#__PURE__*/_jsx("hr", {
        className: "m-bottom-4 m-top-4"
      }) : /*#__PURE__*/_jsx("hr", {}), /*#__PURE__*/_jsx(LoginOptions
      // @ts-expect-error ts-migrate(2322) FIXME: Type '() => void' is not assignable to type '() =>... Remove this comment to see the full error message
      , {
        onGoogleLoginClick: this.handleGoogleLoginClick
        // @ts-expect-error ts-migrate(2322) FIXME: Type '(error: $tsMigrateAny) => void' is not assig... Remove this comment to see the full error message
        ,
        triggerReset: this.triggerReset,
        ssoRender: this.renderSsoLoginButton
      })]
    });
  }
}

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof LoginForm' is not assigna... Remove this comment to see the full error message
LoginForm.propTypes = {
  location: PropTypes.object.isRequired,
  onLoginSubmit: PropTypes.func.isRequired,
  onGoogleLoginClick: PropTypes.func.isRequired,
  onSsoLoginClick: PropTypes.func.isRequired,
  isInvalidTokenAlertVisible: PropTypes.bool,
  loginRedirectUrl: PropTypes.string,
  variant: PropTypes.string
};
export default withRouter(LoginForm);